import React from "react"
import { createNativeStackNavigator } from "@react-navigation/native-stack"
import Forum from "@Screens/Knowledge/SavoirEtre/Forum/Forum"
import ForumTopic from "@Screens/Knowledge/SavoirEtre/Forum/ForumTopic/ForumTopic"

const ForumStackNavigator = createNativeStackNavigator()

const ForumStack = () => (
    <ForumStackNavigator.Navigator
        screenOptions={{
            headerShown: false
        }}
        initialRouteName="ForumScreen"
    >
        {/* <ForumStackNavigator.Screen name="ForumScreen" component={Forum} />
        <ForumStackNavigator.Screen name="ForumTopic" component={ForumTopic} /> */}
    </ForumStackNavigator.Navigator>
)

export default ForumStack
